import { CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AlertController, IonModal, ModalController } from '@ionic/angular';
import { TicketsDetailComponent } from 'src/app/modals/tickets-detail/tickets-detail.component';
import { Bill, Product, StoredBill } from 'src/app/models/bill';
import { Contest, Store, StoreTotal } from 'src/app/models/contest';
import { Question } from 'src/app/models/question';
import { AuthService } from 'src/app/services/auth.service';
import { BillService } from 'src/app/services/bill.service';
import { ConfigService } from 'src/app/services/config.service';
import { ToolsService } from 'src/app/services/tools.service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { ContestService } from 'src/app/services/contest.service';
import { ContestModalComponent } from 'src/app/modals/contest-modal/contest-modal.component';
import { CustomErrorAlertComponent } from '../custom-alert/custom-alert.component';

@Component({
  selector: 'app-bill-detail',
  templateUrl: './bill-detail.component.html',
  styleUrls: ['./bill-detail.component.scss'],
})
export class BillDetailComponent implements OnInit {
  @Input() bill?: Bill;
  @Input() images?: Array<string>;
  @Input() selectedContest?: Contest;
  @Input() stores?: Array<StoreTotal>;

  @ViewChild('alertModal') alertModal!: IonModal;

  @Output() onContinue: EventEmitter<any> = new EventEmitter<any>();
  @Output() onScrollToTop: EventEmitter<any> = new EventEmitter<any>();
  // @Output() onBack: EventEmitter<any> = new EventEmitter<Bill>();
  // @Output() back = new EventEmitter<void>();
  @Output() onBack = new EventEmitter<void>();

  loading: boolean = false;
  billQuestions: Array<Question> = [];
  notValidOptions: Array<string> = [];
  isBillCorrect: boolean = true;
  productsToShow: number = 3;
  activeContests: Array<Contest> = [];

  initialValuesForm: any;
  modifiedFields: any;
  termsAccepted: boolean = false;

  showCustomAlert = false;
  notRecognizedFields = '';

  constructor(
    private toolsService: ToolsService,
    private billService: BillService,
    private alertCtrl: AlertController,
    private modalController: ModalController,
    private currencyPipe: CurrencyPipe,
    public configService: ConfigService,
    private authService: AuthService,
    public contestService: ContestService
  ) {}

  async ngOnInit() {
    this.validateBillData();
    // await this.loadContestStores();
    this.loadQuestions();
    this.initialValuesForm = this.billQuestions.map((question) => {
      return {
        name: question.id,
        value: question.formControl.value,
      };
    });
  }

  async loadContestStores() {
    let data = await this.toolsService.convertObservableToPromise<
      Array<StoreTotal>
    >(this.contestService.getStores());
    this.stores = data;
  }

  getModifiedIds(): string[] {
    const modifiedIds = this.billQuestions
      .filter(
        (question, index) =>
          question.formControl.value !== this.initialValuesForm[index].value
      )
      .map((question) => question.id);

    return modifiedIds;
  }

  async loadQuestions() {
    // let minDate = new Date();
    // let maxDate = new Date();
    // const defaultDaysToValidate = 30;
    // const xDaysAgo = new Date();
    // xDaysAgo.setDate(maxDate.getDate() - defaultDaysToValidate);
    // minDate = xDaysAgo;

    const maxDate = new Date();
    maxDate.setHours(23, 59, 59, 999);

    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 1);
    minDate.setHours(0, 0, 0, 0);


    this.billQuestions = [
      {
        id: 'bill_number',
        label: 'Número de factura *',
        type: 'text',
        formControl: new FormControl(
          this.formatBillNumber(this.bill?.billNumber),
          [
            Validators.required,
            Validators.maxLength(64),
          ]
        ),
        errorText: {
          maxlength: 'El número de factura debe tener máximo 64 caracteres',
        },
      },
      // {
      //   id: 'store',
      //   label: 'Tienda *',
      //   type: 'list-selection',
      //   options: this.stores?.map((store) => ({
      //     value: store.id,
      //     label: store.name,
      //     subLabel: store.document_number + '',
      //   })),
      //   formControl: (() => {
      //     const recognizedValue = this.bill?.store?.document_number;
      //     if (this.stores && recognizedValue) {
      //       const selectedStoreId =
      //         this.stores.find((store) =>
      //           String(recognizedValue).includes(String(store.document_number))
      //         )?.id || null;
      //       return new FormControl(selectedStoreId, [Validators.required]);
      //     } else {
      //       return new FormControl(null, [Validators.required]);
      //     }
      //   })(),
      // },
      {
        id: 'store',
        label: 'Tienda *',
        type: 'list-selection',
        options: this.stores?.map((store) => ({
          value: store.id,
          label: store.name,
          subLabel: String(store.document_number),
        })),

        formControl: (() => {
          let recognizedNit = this.bill?.NIT ? String(this.bill.NIT) : '';
          recognizedNit = recognizedNit.replace(/\D/g, '');

          let selectedStoreId: any = null;

          if (this.stores && recognizedNit) {
            const matched = this.findStoreByNitAndName(
              recognizedNit,
              this.bill?.store_name
            );

            selectedStoreId = matched?.id ?? null;
          }

          return new FormControl(selectedStoreId, [Validators.required]);
        })(),
      },
      {
        id: 'date',
        label: 'Fecha *',
        type: 'date',
        formControl: new FormControl(
          this.bill?.date &&
          this.isValidDate(this.bill.date, minDate, maxDate)
            ? this.bill.date
            : '',
          [Validators.required]
        ),
        minDate: minDate.toISOString(),
        maxDate: maxDate.toISOString(),
        defaultValue: '',
      },
      {
        id: 'time',
        label: 'Hora',
        type: 'time',
        formControl: new FormControl(this.formatTime(this.bill?.hour)),
        defaultValue: '12:00',
      },
      {
        id: 'total',
        label: 'Valor total *',
        type: 'text',
        inputType: 'number',
        formControl: new FormControl(
          this.bill?.total ? Math.round(this.bill.total) : null,
          [Validators.required, Validators.pattern(/^[0-9]+$/)]
        ),
        errorText: { pattern: 'Debes ingresar un valor numérico' },
      },
    ];

    console.debug('BillDetailComponent.loadQuestions()', this.billQuestions);
  }

  /**
   * This method validates if the bill has all the required data to continue
   */
   async validateBillData() {
    console.debug('BillDetailComponent.validateBillData()');

    this.isBillCorrect = true;
    this.notValidOptions = [];

    // Validate if the billNumber exists
    if (!this.bill?.billNumber) {
      console.debug('BillDetailComponent.validateBillData() - billNumber');
      this.isBillCorrect = false;
      this.notValidOptions.push('billNumber');
    }

    // Validate if a store could be matched
    let recognizedNit = this.bill?.NIT ? String(this.bill.NIT) : '';
    recognizedNit = recognizedNit.replace(/\D/g, '');

    let selectedStore: any = null;

    if (this.stores && recognizedNit) {
      selectedStore = this.findStoreByNitAndName(
        recognizedNit,
        this.bill?.store_name
      );
    }

    if (!selectedStore) {
      console.debug('BillDetailComponent.validateBillData() - store');
      this.isBillCorrect = false;
      this.notValidOptions.push('store');
    }

    // Validate if the date exists and is within the allowed range
    const maxDate = new Date();
    maxDate.setHours(23, 59, 59, 999);

    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 1);
    minDate.setHours(0, 0, 0, 0);

    if (
      !this.bill?.date ||
      this.bill.date.trim() === '' ||
      !this.isValidDate(this.bill.date, minDate, maxDate)
    ) {
      console.debug('BillDetailComponent.validateBillData() - date');
      this.isBillCorrect = false;
      this.notValidOptions.push('date');
    }

    // Validate if the hour exists
    if (!this.bill?.hour) {
      console.debug('BillDetailComponent.validateBillData() - hour');
      this.isBillCorrect = false;
      this.notValidOptions.push('hour');
    }

    // Validate if the total exists
    if (!this.bill?.total) {
      console.debug('BillDetailComponent.validateBillData() - total');
      this.isBillCorrect = false;
      this.notValidOptions.push('total');
    }

    if (this.notValidOptions.length > 0) {

      const fields = this.notValidOptions
        .map(field => {
          const labels: any = {
            billNumber: 'Número de factura',
            store: 'Tienda',
            date: 'Fecha',
            hour: 'Hora',
            total: 'Total'
          };

          return `<li>${labels[field] || field}</li>`;
        })
        .join('');

        this.notRecognizedFields = fields;
        this.showCustomAlert = true;

    }
  }

  get products(): Array<Product> {
    return this.bill?.products || [];
  }

  showMoreProducts() {
    if (this.productsToShow != this.products.length)
      this.productsToShow = this.products.length;
    else this.productsToShow = 3;
  }

  correctBill() {
    this.onScrollToTop.emit(true);
    this.isBillCorrect = false;
  }

  changeBill() {
    this.onBack.emit();
  }

  goBack() {
    this.onBack.emit();
  }

  async goBackFromModal() {
    this.showCustomAlert = false;

    await this.alertModal.dismiss();

    this.notValidOptions = [];
    this.notRecognizedFields = '';

    this.onBack.emit();
  }

  async showConfirmBillAlert(bill?: Bill) {

    if (bill && !bill.store) {
      const billNit = bill.NIT;

      if (typeof billNit === 'string') {
        const foundStore = this.stores?.find(store => {
          const docNumber = store.document_number || '';
          return docNumber === billNit ||
                 (docNumber.startsWith(billNit) && docNumber.length === billNit.length + 1);
        });

        if (foundStore) {
          bill.store = foundStore as any;
        }
      }
    }

    let total = this.toolsService.getValueFromBillId(
      'total',
      this.billQuestions
    );
    total = this.currencyPipe.transform(total, '', 'symbol', '1.0-0');
    let billNumber = this.toolsService.getValueFromBillId(
      'bill_number',
      this.billQuestions
    );

    const alert = await this.alertCtrl.create({
      header: 'Importante',
      message: `
      <h4>¿Estás seguro de que la factura <strong>${billNumber}</strong> tiene un valor de <strong>${total}</strong>?</br>
      Recuerda que estos datos deben coincidir para que la factura sea válida</br>
      <i>Los datos enviados no podrán cambiarse</i>
      </h4>`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Confirmar',
          handler: () => {
            this.storeBill(bill);
          },
        },
      ],
    });
    await alert.present();
  }

  validateForm() {
    let hasError: boolean = false;
    for (let question of this.billQuestions) {
      if (question.formControl.invalid) {
        question.formControl.markAsTouched();
        hasError = true;
      }
    }

    return hasError;
  }

  continue() {
    console.debug('BillDetailComponent.continue()');

    this.modifiedFields = this.getModifiedIds();
    if (this.modifiedFields.length > 0) {
      console.debug(
        'Se han modificado los siguientes campos:',
        this.modifiedFields
      );
    } else {
      console.debug('No se han realizado cambios');
    }

    if (this.isBillCorrect) return this.showConfirmBillAlert(this.bill);
    // First validate form
    if (this.validateForm()) return;

    let storeId = this.toolsService.getValueFromBillId(
      'store',
      this.billQuestions
    );
    let selectedStore: StoreTotal | undefined = this.stores?.find(
      (store) => store.id == storeId
    );
    if (!selectedStore)
      return this.toolsService.presentErrorToast(
        'La tienda seleccionada no se encuentra en el sistema'
      );

    // Create the bill with the data of the form
    let billToStore: Bill = {
      billNumber: this.toolsService.getValueFromBillId(
        'bill_number',
        this.billQuestions
      ),
      store: selectedStore,
      date: this.toolsService.getValueFromBillId('date', this.billQuestions),
      hour: this.toolsService.getValueFromBillId('time', this.billQuestions),
      total: this.toolsService.getValueFromBillId('total', this.billQuestions),
      products: this.bill?.products || [],
      store_name: this.bill?.store_name,
      azureResponse: this.bill?.azureResponse,
      billRequest: this.bill?.billRequest,
      modified_fields: this.modifiedFields,
    };
    return this.showConfirmBillAlert(billToStore);
  }

  async storeBill(bill?: Bill) {
    if (!bill) return;
    console.debug('BillDetailComponent.storeBill()', bill);

    // 🔹 Formatear la hora correctamente
    bill['hour'] = this.formatTime(this.bill?.hour);
    this.loading = true;

    // 🔹 Asignar rol al canal antes de continuar
    this.authService.assignRoleToChannel().subscribe({
      next: (res) => console.debug('Rol asignado al canal:', res),
      error: (err) => console.warn('Error al asignar rol al canal:', err),
    });

    try {

      let storeId = bill?.store?.id;
      const billNit = bill?.NIT;

      if (!storeId && typeof billNit === 'string') {
        const foundStore = this.stores?.find(store => {
          const docNumber = store.document_number || "";

          return docNumber === billNit ||
                 (docNumber.startsWith(billNit) && docNumber.length === billNit.length + 1);
        });

        storeId = foundStore?.id;

      }

      await this.loadActiveContests(bill?.date, storeId);

      // await this.loadActiveContests(bill?.date, bill?.store?.id);
      if (!this.activeContests || this.activeContests.length === 0) {
        this.loading = false;
        return this.toolsService.presentErrorToast(
          'No hay concursos activos disponibles.'
        );
      }

      console.debug('Concursos activos obtenidos:', this.activeContests);

      // 2️⃣ Arreglo para almacenar los concursos exitosos
      const successfulContests: Contest[] = [];

      // 3️⃣ Enviar la factura a cada concurso activo
      for (const contest of this.activeContests) {
        try {
          console.debug(`Enviando factura al concurso: ${contest.id}`);

          const storedBill =
            await this.toolsService.convertObservableToPromise<StoredBill>(
              this.billService.storeBill(
                bill,
                contest.id,
                this.images,
                !this.isBillCorrect,
                this.notValidOptions
              )
            );

          console.debug(
            `Factura guardada en concurso ${contest.id}`,
            storedBill
          );

          // Asociar el resultado a la instancia del concurso
          successfulContests.push({
            ...contest,
          });
        } catch (error) {
          console.warn(
            `Error al guardar factura en el concurso ${contest.id}`,
            error
          );
        }
      }

      // 4️⃣ Mostrar modal con los concursos exitosos
      this.loading = false;

      if (successfulContests.length > 0) {
        await this.openContestModal(successfulContests);
        console.debug(
          'Facturas almacenadas correctamente en:',
          successfulContests.length,
          'concursos'
        );
      } else {
        this.toolsService.presentErrorToast(
          'La factura cargada no cumple con los requisitos necesarios para participar en ninguno de los concursos disponibles.'
        );
      }
    } catch (error) {
      this.loading = false;
      console.error('Error general en storeBill()', error);
      this.handleStoreBillError(error);
    }
  }

  async loadActiveContests(
    billDate: string | null,
    storeId: string | undefined
  ) {
    return new Promise((resolve, reject) => {
      this.contestService.listContestsEligible(billDate, storeId).subscribe({
        next: (data) => {
          this.activeContests = data.campaigns;
          return resolve(data);
        },
        error: (err) => {
          console.debug(err);
          return resolve(err);
        },
      });
    });
  }

  async openTermsAndConditions() {
    const storeId = this.toolsService.getValueFromBillId(
      'store',
      this.billQuestions
    );
    const billDate = this.toolsService.getValueFromBillId(
      'date',
      this.billQuestions
    );

    if (!storeId)
      return this.toolsService.presentErrorToast(
        'Debes seleccionar una tienda antes de ver los términos.'
      );

    if (!billDate)
      return this.toolsService.presentErrorToast(
        'Debes seleccionar una fecha antes de ver los términos.'
      );

    const resp: any = await this.loadActiveContests(billDate, storeId);

    if (!resp?.campaigns?.length)
      return this.toolsService.presentErrorToast(
        'No hay concursos disponibles.'
      );

    const windows: Array<Window | null> = resp.campaigns.map(() =>
      window.open('', '_blank')
    );

    resp.campaigns.forEach((contest: any, index: number) => {
      const win = windows[index];
      if (contest.terms_and_conditions && win) {
        win.location.href = contest.terms_and_conditions;
      }
    });
  }

  async openContestModal(contests: any[]) {
    const modifiedBill = this.modifiedFields?.length > 0;

    const modal = await this.modalController.create({
      component: ContestModalComponent,
      cssClass: 'custom-content-modal',
      componentProps: {
        contests,
        modifiedBill
      },
    });

    await modal.present();
    const { data } = await modal.onDidDismiss();

    if (data === true) {
      this.onContinue.emit({ next: 'upload-bill' });
    } else {
      this.onContinue.emit({ next: 'login' });
    }
  }

  handleStoreBillError(error: any) {
    console.error('BillDetailComponent.handleStoreBillError()', error);
    if (error.status != 400)
      return this.toolsService.presentErrorToast(
        'Ha ocurrido un error al guardar la factura, intenta de nuevo más tarde'
      );
    let errorMessage = '';

    // if (error.error.bill_number) errorMessage += "El número de la factura ya se encuentra registrado en el sistema</br>";
    // Si el error contiene un mensaje que coincide con el formato del ejemplo
    if (error.error && error.error.message) {
      const message = error.error.message;
      if (
        message.includes('Bill number') &&
        message.includes('already exists')
      ) {
        const billNumber = message.match(/Bill number\s+(.+?)\s+already exists/i)?.[1];

        errorMessage += `El número de la factura ${billNumber} ya se encuentra registrado en el sistema</br>`;
      } else if (
        message.includes('Total amount') &&
        message.includes('must be greater')
      ) {
        try {
          let number = parseFloat(message.match(/(\d+(\.\d+)?)(?=\s*$)/)[0]);
          let formattedNumber = `$${number.toLocaleString('en-US', {
            minimumFractionDigits: 0,
          })}`;
          errorMessage += `El valor total de la factura debe ser mayor a ${formattedNumber}</br>`;
        } catch (error) {
          errorMessage +=
            'El valor total de la factura no esta dentro del rango permitido</br>';
        }
      }
    }

    if (error.error.store)
      errorMessage +=
        'La tienda seleccionada no se encuentra participando en el concurso</br>';
    if (error.error.contest) errorMessage += 'El concurso ha finalizado</br>';
    if (error.error.images)
      errorMessage += 'No se pudieron subir las imágenes</br>';

    if (error.error.non_field_errors) {
      error.error.non_field_errors.forEach((element: string) => {
        if (element.indexOf('Store prefix') != -1)
          errorMessage += 'La factura no tiene un prefijo válido</br>';
        else if (element.indexOf('Date must be') != -1)
          errorMessage +=
            'La fecha ingresada no se encuentra dentro de las fechas del concurso</br>';
      });
    }

    this.toolsService.presentErrorToast(errorMessage);

    this.loading = false;
    return null;
  }

  async showSuccesUploadConfirmation(storedBill: StoredBill) {
    if (
      storedBill.status == 'PENDING' ||
      this.selectedContest?.campaign_type != 'tickets'
    )
      return this.showFinalConfirmation(storedBill);
    let generatedTickets: any;
    await this.toolsService.showLoading('Validando información...');
    try {
      generatedTickets =
        await this.toolsService.convertObservableToPromise<any>(
          this.billService.listGeneratedTickets(this.selectedContest!.id)
        );
      await this.toolsService.hideLoading();
    } catch (error) {
      console.error(
        'BillDetailComponent.showSuccesUploadConfirmation() - listGeneratedTickets',
        error
      );
      await this.toolsService.hideLoading();
      return this.showFinalConfirmation(storedBill);
    }
    if (generatedTickets.length == 0)
      return this.showFinalConfirmation(storedBill);

    let message = `La factura <strong>${storedBill.bill_number}</strong> se ha enviado correctamente. Actualmente tienes los siguientes tickets participando en el concurso:</br></br>`;
    generatedTickets.forEach((ticket: any) => {
      message += `<li>${ticket.id}</li>`;
    });
    message += `</ul>`;
    let buttons = [];
    buttons.push({
      text: 'Enviar otra factura',
      handler: () => {
        this.onContinue.emit({ next: 'upload-bill' });
      },
    });
    if (this.billService.adminToken) {
      buttons.push({
        text: 'Ver detalle de los tickets',
        handler: () => {
          this.showTicketsDetail(generatedTickets);
          return false;
        },
      });
    }
    buttons.push({
      text: 'Salir',
      handler: () => {
        this.onContinue.emit({ next: 'login' });
      },
    });

    const alert = await this.alertCtrl.create({
      header: '¡Gracias por participar!',
      message: message,
      backdropDismiss: false,
      buttons: buttons,
    });
    alert.present();
  }

  async showFinalConfirmation(storedBill: StoredBill) {
    if (this.selectedContest?.confirmation_message)
      await this.showConfirmationModal(storedBill);
    console.debug(
      'BillDetailComponent.showSuccesUploadConfirmation()',
      storedBill
    );
    let message = `La factura <strong>${storedBill.bill_number}</strong> se ha enviado correctamente`;
    if (storedBill.status == 'PENDING')
      message = `La factura <strong>${storedBill.bill_number}</strong> se ha enviado correctamente y se encuentra en proceso de validación`;
    const alert = await this.alertCtrl.create({
      header: '¡Gracias por participar!',
      message: message,
      backdropDismiss: false,
      buttons: [
        {
          text: 'Enviar otra factura',
          handler: () => {
            this.onContinue.emit({ next: 'upload-bill' });
          },
          // }, {
          //   text: 'Ver mis facturas',
          //   handler: () => {
          //     this.onContinue.emit({ 'next': 'get-bills' });
          //   }
        },
        {
          text: 'Salir',
          handler: () => {
            this.onContinue.emit({ next: 'login' });
          },
        },
      ],
    });
    await alert.present();
  }

  showConfirmationModal(storedBill: StoredBill) {
    return new Promise(async (resolve, reject) => {
      const modal = await this.modalController.create({
        component: ConfirmationModalComponent,
        componentProps: {
          contest: this.selectedContest,
          storedBill: storedBill,
        },
      });
      modal.onDidDismiss().then((data) => {
        console.debug('BillDetailComponent.showConfirmationModal()', data);
        resolve(data);
      });
      return modal.present();
    });
  }

  isValidDate(date: any | Date, minDate: Date, maxDate: Date): boolean {
    const dateToValidate = new Date(date);
    return dateToValidate >= minDate && dateToValidate <= maxDate;
  }

  async showTicketsDetail(generatedTickets: any) {
    const modal = await this.modalController.create({
      component: TicketsDetailComponent,
      componentProps: {
        contest: this.selectedContest,
        generatedTickets: generatedTickets,
      },
      cssClass: 'tickets-detail-modal',
    });
    modal.onDidDismiss().then((data) => {
      console.debug('BillDetailComponent.showTicketsDetail()', data);
    });
    return modal.present();
  }

  formatTime(time: string | null | undefined): string {
    if (!time) return '';
    const [hour, minute] = time.split(':');
    return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
  }

  formatBillNumber(value: string | null | undefined): string {
    if (!value) return '';
    return String(value).replace(/[^a-zA-Z0-9]/g, '');
  }

  private findStoreByNitAndName(nit: string, recognizedStoreName?: string | null) {
    const incomingNit = String(nit).replace(/\D/g, '').trim();
    if (!incomingNit || !this.stores?.length) return null;

    let candidates = this.stores.filter(
      store => String(store.document_number).replace(/\D/g, '').trim() === incomingNit
    );

    if (candidates.length === 0) {
      candidates = this.stores.filter(store => {
        const storeNit = String(store.document_number).replace(/\D/g, '').trim();
        return storeNit.slice(0, -1) === incomingNit;
      });
    }

    if (candidates.length <= 1) {
      return candidates[0] ?? null;
    }

    return this.findClosestStoreByName(candidates, recognizedStoreName);
  }

  private findClosestStoreByName(
    stores: StoreTotal[],
    recognizedStoreName?: string | null
  ) {
    const normalizedRecognizedName = this.normalizeTextForComparison(recognizedStoreName);
    if (!normalizedRecognizedName) {
      return stores[0] ?? null;
    }

    const rankedStores = stores
      .map(store => {
        const nameDistance = this.levenshteinDistance(
          normalizedRecognizedName,
          this.normalizeTextForComparison(store.name)
        );
        const completeNameDistance = this.levenshteinDistance(
          normalizedRecognizedName,
          this.normalizeTextForComparison(store.complete_name)
        );

        return {
          store,
          distance: Math.min(nameDistance, completeNameDistance),
        };
      })
      .sort((a, b) => a.distance - b.distance);

    return rankedStores[0]?.store ?? null;
  }

  private normalizeTextForComparison(value?: string | null): string {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]/g, '')
      .toLowerCase();
  }

  private levenshteinDistance(a: string, b: string): number {
    if (!a) return b.length;
    if (!b) return a.length;

    const matrix = Array.from({ length: b.length + 1 }, (_, i) => [i]);

    for (let j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
    }

    for (let i = 1; i <= b.length; i++) {
      for (let j = 1; j <= a.length; j++) {
        matrix[i][j] = b.charAt(i - 1) === a.charAt(j - 1)
          ? matrix[i - 1][j - 1]
          : Math.min(
              matrix[i - 1][j - 1] + 1,
              matrix[i][j - 1] + 1,
              matrix[i - 1][j] + 1
            );
      }
    }

    return matrix[b.length][a.length];
  }

  dismissAlertModal() {
    this.showCustomAlert = false;
  }

  get canEditFields(): boolean {
    return !!this.selectedContest?.manual_validation;
  }

  get fieldsCount(): number {
    if (!this.notRecognizedFields) {
      return 0;
    }

    return (this.notRecognizedFields.match(/<li>/g) || []).length;
  }

  get notRecognizedFieldsList(): string[] {
    return this.notRecognizedFields
      ?.match(/<li>(.*?)<\/li>/g)
      ?.map(item => item.replace(/<\/?li>/g, '').trim()) ?? [];
  }


}
